import { lazy } from 'react';

function lazyWithFallback(importFunc) {
  return lazy(() => importFunc().then((module) => ({ default: module.default })));
}

export default lazyWithFallback;
